import React, { useState, useEffect } from "react";
import api from "../../api/client";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

export default function SslDomainModal({ open, onClose, server }) {
  const [domainsInput, setDomainsInput] = useState("");

  useEffect(() => {
    if (server) setDomainsInput(server.domain_name || "");
  }, [server]);

  const handleUpdateDomains = async () => {
    try {
      await api.put(`/servers/${server.id}/domains`, {
        domain_name: domainsInput,
      });
      onClose();
      window.location.reload();
    } catch (error) {
      alert("Domainler güncellenirken hata oluştu.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: "#0a0a0d",
          borderRadius: 4,
          border: "1px solid rgba(234,240,248,0.1)",
          minWidth: "400px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          borderBottom: "1px solid rgba(234,240,248,0.05)",
        }}
      >
        SSL Domainlerini Düzenle
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="caption" color="text.secondary" paragraph>
          Birden fazla domain izlemek için aralarına virgül (,) koyun.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={domainsInput}
          onChange={(e) => setDomainsInput(e.target.value)}
          slotProps={{
            input: {
              sx: {
                bgcolor: "rgba(234,240,248,0.03)",
                color: "text.primary",
                fontFamily: '"Geist Mono", ui-monospace, monospace',
              },
            },
          }}
        />
      </DialogContent>
      <DialogActions
        sx={{ p: 2, borderTop: "1px solid rgba(234,240,248,0.05)" }}
      >
        <Button onClick={onClose} sx={{ color: "text.secondary" }}>
          İptal
        </Button>
        <Button
          onClick={handleUpdateDomains}
          variant="contained"
          color="secondary"
          sx={{ fontWeight: "bold", borderRadius: 2 }}
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
